export default {
  path: '/2019PaintingAndCalligraphyCompetition',
  name: '2019PaintingAndCalligraphyCompetition',
  component: () => import('./Home.vue'),
  redirect: '/2019PaintingAndCalligraphyCompetition/OnDisply',
  meta: {
    title: '乡村学校少年宫书画大赛',
  },
  children: [
    {
      path: 'OnDisply',
      component: () => import('./OnDisply.vue'),
      name: 'OnDisply',
      meta: {
        title: '乡村学校少年宫书画大赛',
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: 'rules',
      meta: {
        title: '乡村学校少年宫书画大赛',
      },
    },
    {
      path: 'list',
      component: () => import('./List.vue'),
      name: 'List',
      meta: {
        title: '乡村学校少年宫书画大赛',
      },
    },
    {
      path: 'detail',
      component: () => import('./Detail.vue'),
      name: 'Detail',
      meta: {
        title: '乡村学校少年宫书画大赛',
      },
    },
  ],
};
